import React from "react";
import { Box, Button, createStyles, darken, Grid, Theme, Typography } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import styled from "styled-components";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { green, orange } from "@material-ui/core/colors";
import { Assort } from "../../../models/Assort";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";

interface IProps {
  ticket: Assort;
  onBtnClick: (ticket: Assort) => void;
  isSelected: boolean;
}

const ExerciseButton = styled(Button)`
  display: inline;
  width: 50%;
  min-height: "4vw";
  border: "1px solid #fff";
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    free: {
      backgroundColor: green[400],
      color: theme.palette.getContrastText(green[400]),
      "&:hover": {
        backgroundColor: darken(green[400], 0.1),
      },
      borderRadius: 0,
    },
    selected: {
      backgroundColor: orange[400],
      color: theme.palette.getContrastText(orange[400]),
      "&:hover": {
        backgroundColor: darken(orange[400], 0.1),
      },
      borderRadius: 0,
    },
  })
);

const TicketButtonSet: React.FC<IProps> = ({ ticket, onBtnClick, isSelected }: IProps) => {
  const classes = useStyles();
  return (
    <Tooltip title={"Wybierz bilet"} placement="top">
      <ExerciseButton
        variant={"contained"}
        className={isSelected ? classes.selected : classes.free}
        onClick={() => onBtnClick(ticket)}
      >
        <Grid container alignItems={"center"}>
          <Grid item xs={9}>
            <Typography variant={"button"} display={"block"} noWrap>
              {ticket.name}
            </Typography>
            <Typography variant={"caption"} display={"block"}>
              {ticket.listPrice.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <ConfirmationNumberIcon style={{ fontSize: 40 }} />
          </Grid>
        </Grid>
      </ExerciseButton>
    </Tooltip>
  );
};

export default TicketButtonSet;
